import { COOKIE_BROADBAND_SEARCH } from '@/constants/cookies';
import { PRODUCT_BROADBAND } from '@/constants/products';
import lang from '@/lang/middleware/products/broadband';
import { getProviders } from '@/graphql/queries/shared/institution';

export default async ({ $apolloQuery, $cookies, $currency, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  $cookies.remove(COOKIE_BROADBAND_SEARCH);
  await $apolloQuery(getProviders, { product: PRODUCT_BROADBAND }).then(providers => store.commit('providers/setList', providers));
  const cheapest = $currency(store.getters['utils/getAmounts'].cheapest_broadband);
  const subtitle = store.$i18n.t('index.jumbotron.subtitle', { cheapest });
  const title = store.$i18n.t('index.jumbotron.title');
  store.commit('search/reset', { type: 'broadband' });
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'expanded' });
  store.commit('pageContent/setHead', { description: store.$i18n.t('index.description'), title: store.$i18n.t('index.title') });
};
